var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 23,
    fill: "#FDF3E1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6855_60077)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8047 14.5884C21.8047 16.1477 20.5403 17.4121 18.981 17.4121C17.4216 17.4121 16.1572 16.1477 16.1572 14.5884C16.1572 13.0291 17.4216 11.7646 18.981 11.7646C20.5403 11.7646 21.8047 13.0291 21.8047 14.5884ZM29.9622 14.5884C29.9622 16.1477 28.6978 17.4121 27.1385 17.4121C25.5791 17.4121 24.3147 16.1477 24.3147 14.5884C24.3147 13.0291 25.5791 11.7646 27.1385 11.7646C28.6978 11.7646 29.9622 13.0291 29.9622 14.5884Z",
    fill: "#FFA726"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.04 26.825C18.04 26.825 16.785 23.6875 13.02 23.6875C9.255 23.6875 8 26.825 8 26.825V28.08H18.04V26.825Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1578 19.2947C16.1578 21.0273 14.7528 22.4322 13.0203 22.4322C11.2878 22.4322 9.88281 21.0273 9.88281 19.2947C9.88281 17.5622 11.2878 16.1572 13.0203 16.1572C14.7528 16.1572 16.1578 17.5622 16.1578 19.2947Z",
    fill: "#FFB74D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1201 26.825C38.1201 26.825 36.8651 23.6875 33.1001 23.6875C29.3351 23.6875 28.0801 26.825 28.0801 26.825V28.08H38.1201V26.825Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2374 19.2947C36.2374 21.0273 34.8325 22.4322 33.0999 22.4322C31.3674 22.4322 29.9624 21.0273 29.9624 19.2947C29.9624 17.5622 31.3674 16.1572 33.0999 16.1572C34.8325 16.1572 36.2374 17.5622 36.2374 19.2947ZM26.8249 23.0597C26.8249 25.1386 25.1388 26.8247 23.0599 26.8247C20.981 26.8247 19.2949 25.1386 19.2949 23.0597C19.2949 20.9808 20.981 19.2947 23.0599 19.2947C25.1388 19.2947 26.8249 20.9808 26.8249 23.0597Z",
    fill: "#FFB74D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9622 32.4726C29.9622 32.4726 28.064 28.0801 23.0597 28.0801C18.0554 28.0801 16.1572 32.4726 16.1572 32.4726V34.3551H29.9622V32.4726Z",
    fill: "#607D8B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6855_60077"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.12,
    height: 30.12,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupChat);
export default __webpack_public_path__ + "static/media/group_chat.60708337.svg";
export { ForwardRef as ReactComponent };